    <template>
  <div>
    <b-modal id="UpdateDetails" size="xl" class="modal has-overflow">
      <template v-slot:modal-header>
        <div class="w-100">
          <h4 class="e-mtavr-17 e-bold modal-title"><span class="e-text-eng-1"># {{update.referenceNumber}} </span>ჩანაწერის დეტალები - სტატუსი:
            <span class="badge e-text-eng-1" :class="{'badge-primary': update.actionType ==='ADD',
                                       'badge-warning': update.actionType ==='EDIT',
                                       'badge-success': update.actionType ==='DEL'
                                       }"> {{update.actionType}} </span> - ცვლილების თარიღი: <span class="e-text-eng-1">{{update.dateGenerated | momentDate}}</span>
          </h4>
        </div>
      </template>
                <!-- <span v-for="upd in update" :key="upd.$index">{{upd}}</span> -->
        <div class="row">
          <div class="col-12">
            <table class="table b-table">
              <thead class="e-nusx-8">
                <tr>
                  <th colspan="2" class="text-center e-bold">პერსონალური ინფორმაცია</th>
                  <th class="text-center e-bold">დამატებითი ინფორმაცია</th>
                </tr>
              </thead>
              <tbody class="e-text-eng-1">
                <tr>
                  <th class="e-nusx-8 w-25"><strong>ყველა ცნობილი სახელი: </strong></th>
                  <td class="w-25">{{update.firstName}}, {{update.secondName}}, {{update.thirdName}}, {{update.fourthName}}</td>
                  <td rowspan="9">
                    <table class="table b-table">
                      <thead class="e-nusx-8">
                        <tr>
                          <th colspan="5" class="text-center">ინფორმაცია მისამართებზე</th>
                        </tr>
                        <tr class=" e-ts-07rem">
                          <th>განახლების ტიპი</th>
                          <th>ქვეყანა</th>
                          <th>ქალაქი</th>
                          <th>მისამართი</th>
                          <th>ინფორმაცია</th>
                        </tr>
                      </thead>
                      <tbody class="e-ts-07rem">
                        <tr v-for="addr in update.addresses" :key="addr.$index">
                          <td>
                               <span class="badge e-text-eng-1" :class="{'badge-primary': addr.actionType ==='ADD',
                                       'badge-warning': addr.actionType ==='EDIT',
                                       'badge-success': addr.actionType ==='DEL'
                                       }"> {{addr.actionType}} </span>
                          </td>
                          <td>{{addr.country === '' || addr.country === null ? 'ჩანაწერი ცარიელია' : addr.country}}</td>
                          <td>{{addr.city === '' || addr.city === null ? 'ჩანაწერი ცარიელია' : addr.city}}</td>
                          <td>{{addr.street === '' || addr.street === null ? 'ჩანაწერი ცარიელია' : addr.street}}</td>
                          <td>{{addr.note === '' || addr.note === null ? 'ჩანაწერი ცარიელია' : addr.note}}</td>
                        </tr>
                      </tbody>
                    </table>
                    <table class="table b-table">
                      <thead class="e-nusx-8">
                        <tr>
                          <th colspan="5" class="text-center">ინფორმაცია დოკუმენტებზე</th>
                        </tr>
                        <tr class=" e-ts-07rem">
                          <th>განახლების ტიპი</th>
                          <th>გამცემი ქვეყანა</th>
                          <th>გაცემის თარიღი</th>
                          <th>დოკუმენტის ტიპი</th>
                          <th>ინფორმაცია</th>
                        </tr>
                      </thead>
                      <tbody class="e-ts-07rem">
                        <tr v-for="doc in update.documents" :key="doc.$index">
                          <td>
                               <span class="badge e-text-eng-1" :class="{'badge-primary': doc.actionType ==='ADD',
                                       'badge-warning': doc.actionType ==='EDIT',
                                       'badge-success': doc.actionType ==='DEL'
                                       }"> {{doc.actionType}} </span>
                          </td>
                          <td>{{doc.countryOfIssue === '' || doc.countryOfIssue === null ? 'ჩანაწერი ცარიელია' : doc.countryOfIssue}}</td>
                          <td>{{doc.dateOfIssue === '' || doc.dateOfIssue === null ? 'ჩანაწერი ცარიელია' : doc.dateOfIssue | momentDate}}</td>
                          <td>{{doc.typeOfDocument === '' || doc.typeOfDocument === null ? 'ჩანაწერი ცარიელია' : doc.typeOfDocument}}
                            {{doc.typeOfDocument2 === '' || doc.typeOfDocument2 === null ? '' : doc.typeOfDocument2}}
                          </td>
                          <td>{{doc.note === '' || doc.note === null ? 'ჩანაწერი ცარიელია' : doc.note}}</td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
                <tr>
                  <th class="e-nusx-8"><strong>მოქალაქეობა: </strong></th>
                  <td>{{update.nationality}}</td>
                </tr>
                <tr>
                  <th class="e-nusx-8"><strong>დაბადების თარიღი: </strong></th>
                  <td>{{update.birthDate | momentDate}}</td>
                </tr>
                <tr>
                  <th class="e-nusx-8"><strong>დაბადების ქვეყანა: </strong></th>
                  <td>{{update.birthStateCountry}}</td>
                </tr>
                <tr>
                  <th class="e-nusx-8"><strong>დაბადების ქალაქი: </strong></th>
                  <td>{{update.birthCity}}</td>
                </tr>
                 <tr>
                  <th class="e-nusx-8"><strong>სქესი: </strong></th>
                  <td>{{update.gender}}</td>
                </tr>
                <tr>
                  <th class="e-nusx-8"><strong>სანქცირების თარიღი: </strong></th>
                  <td>{{update.listedOn | momentDate}}</td>
                </tr>
                <tr>
                  <th class="e-nusx-8"><strong>ჩანაწერის ტიპი: </strong></th>
                  <td>{{update.unListType}}</td>
                </tr>
                <tr>
                  <th class="e-nusx-8"><strong>სახელის ორიგინალი დამწერლობა: </strong></th>
                  <td>{{update.nameOriginalScript}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      <template v-slot:modal-footer>
        <div class="w-100">
          <!-- <b-button
            size="sm"
            variant="btn btn-purple"
            @click="save()"
            class="float-right e-mtavr-17"
            >შენახვა</b-button
          > -->
          <b-button
            size="sm"
            variant="btn btn-secondary"
            @click="close('UpdateDetails')"
            class="float-right e-mtavr-17 mr-2"
            >დახურვა</b-button
          >
        </div>
      </template>
    </b-modal>
  </div>
</template>
<script>
import moment from 'moment'
export default {
  name: 'UpdatesDetailsModal',
  props: ['update'],
  data () {
    return {
      showDetails: false
    }
  },
  mounted () {
  },
  created () {
  },
  methods: {
    close (id) {
      this.showDetails = false
      this.$bvModal.hide(id)
    },
    ShowDetails (data) {
      this.showDetails = true
    }
  },
  filters: {
    momentDate (date) {
      return moment(date).format('DD.MM.YYYY')
    },
    momentDateTime (date) {
      return moment(date).format('DD.MM.YYYY HH:mm:SS')
    }
  }
}
</script>
